








































import {Component} from 'vue-property-decorator'
import {TokensTableItemsCollection} from '@/model/collection/TokensTableItemsCollection'
import {MixinScreenSize} from '../mixins/MixinScreenSize'
import {Prop} from 'vue-property-decorator'
import LastPriceUpdated from '../LastPriceUpdated.vue'
import PoweredBy, {PoweredByItem} from '../PoweredBy.vue'
import TokensPriceScrollableTable from '../TokensPriceScrollableTable.vue'
import moment from 'moment'

@Component({
  components: {
    LastPriceUpdated,
    PoweredBy,
    TokensPriceScrollableTable,
  },
})
export default class DappDetailedTokensContent extends MixinScreenSize {
  @Prop({type: TokensTableItemsCollection, required: true})
  tokensTableItemsCollection!: TokensTableItemsCollection

  poweredByList = [
    {
      url: 'https://flamingo.finance/',
      alt: 'flamingo icon',
      filename: 'flamingo-icon.svg',
    } as PoweredByItem,
    {
      url: 'https://www.forthewin.network/#/',
      alt: 'ftwicon',
      filename: 'for-the-win-logo.svg',
    } as PoweredByItem,
    {
      url: 'https://neofura-1.gitbook.io/api-docs/',
      alt: 'magnet icon',
      filename: 'magnet-icon.svg',
    } as PoweredByItem,
    {
      url: 'https://carrot-fi.xyz/',
      alt: 'carrot swap icon',
      filename: 'carrot-swap.svg',
    } as PoweredByItem,
  ]

  formattedLastTimeUpdated() {
    return moment(this.tokensTableItemsCollection.lastTimeUpdated).format(
      'DD-MM-YYYY | HH:mm (UTC)'
    )
  }
}
